import { Injectable } from "@angular/core";
declare let THREE: any;
import { CameraService } from "./camera.service";

@Injectable()
export class RendererService {
  renderer = new THREE.WebGLRenderer({
    antialias: true,
    preserveDrawingBuffer: true,
    alpha: true
  });

  constructor(private cameraManager: CameraService) {
    const renderer = this.renderer;
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setClearColor(0xffffff, 1);
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.gammaInput = true;
    renderer.gammaOutput = true;
    renderer.gammaFactor = 1;
    this.renderer.localClippingEnabled = true;
    const canvas = this.renderer.domElement as HTMLElement;
    canvas.style.touchAction = 'none';
    (canvas.style as any).msTouchAction = 'none';
    const wnd = window as any;
    if (wnd.configRenderer) {
      wnd.configRenderer(renderer);
    }
    wnd.renderer = this.renderer;
  }

  get() {
    return this.renderer;
  }

  render(scene) {
    this.renderer.render(scene, this.cameraManager.camera);
  }

  getCanvas() {
    return this.renderer.domElement;
  }

  resize(w, h, update?) {
    let def = true;
    if (update) {
      def = false;
    }
    this.renderer.setSize(w, h, def);
  }

  getMaxAnisotropy() {
    return this.renderer.getMaxAnisotropy();
  }

  getScreenShot() {
    return this.renderer.domElement.toDataURL("image/png");
  }

  getContext() {
    return this.renderer.getContext();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/renderer.service.ts